module.exports = __webpack_public_path__ + "static/media/HCMM408.2aa48542.jpg";